import React from 'react'
import { ZariContext } from '_zari/context'
import { Portlet, Table } from '_zari/core'
import * as MarcaCrud from 'services/marca.service'
import NuevaMarcaModal from '../modals/nuevaMarcaModal'

const portletBreadcrumbs = [{ name: 'Marcas' }]

const tableHeaderRows = [
  {
    label: 'NOMBRE',
    filter: {
      type: 'text',
      name: 'nom'
    }
  },
  {
    label: ''
  }
]

const ListaMarcasPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)
  const [editData, seteditData] = React.useState({ nombre: '', title: 'Nueva Marca', id: '' })
  const tablaRef = React.useRef(null)

  const [mostrarNuevaMarcaModal, setMostrarNuevaMarcaModal] = React.useState(false)

  const activarModal = () => setMostrarNuevaMarcaModal(true)

  const clickNuevo = React.useCallback(() => {
    seteditData({ nombre: '', title: 'Nueva Marca', id: '' })
    activarModal()
  }, [])

  const clickEditar = React.useCallback(
    async ({ _id }) => {
      await MarcaCrud.getMarca(_id)
        .then(({ data }) => {
          seteditData({ nombre: data.nombre, title: 'Editar Marca', id: _id })
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
      activarModal()
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await MarcaCrud.eliminarMarca(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <>
        <Portlet>
          <Portlet.Header title='Marcas' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
          <Portlet.Body>
            <Table.ServerSide
              ref={tablaRef}
              useNest={true}
              useFilters={true}
              url='/marcas'
              headRows={tableHeaderRows}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.nombre || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Portlet.Body>
        </Portlet>
      </>
      {mostrarNuevaMarcaModal && (
        <NuevaMarcaModal show={mostrarNuevaMarcaModal} handleClose={() => setMostrarNuevaMarcaModal(false)} editData={editData} tablaRef={tablaRef} />
      )}
    </>
  )
}

export default ListaMarcasPage
